<template>
  <div class="sub-filter columns">

    <div class="column">
      <h3>הצג:</h3>
      <div class="select is-success">
        <select v-model="sortby" @change="getSortlist">
          <option value="all">הכל</option>
          <option value="monthly">מנוי חודשי</option>
          <option value="yearly">מנוי שנתי</option>
          <option value="gift">מנוי מתנה</option>
          <option value="reporter">עיתונאי</option>
          <option value="teacher">מורים</option>
          <option value="active">מנויים פעילים</option>
          <option value="canceled">מנויים מושעים</option>
        </select>
      </div>
    </div>

    <div class="column">
      <h3>סדר לפי</h3>
      <div class="select is-primary">
        <select v-model="orderby"
        @change="setOrderby">
          <option value="nextPayment">תאריך התשלום הבא</option>
          <option value="name">שם</option>
        </select>
      </div>
    </div>

    <div class="column">
      <h3>כיוון</h3>
      <div class="select is-primary">
        <select v-model="sortdir"
        @change="setSortDir">
          <option value="up">סדר עולה</option>
          <option value="down">סדר יורד</option>
        </select>
      </div>
    </div>

    <div class="column text-search">
      <h3>סינון לפי שם, אימייל או מספר ת"ז</h3>
      <div class="field">
        <div class="control">
          <input class="input is-success" v-model="term" type="text" placeholder="שם, אימייל או תעודת זהות">
          <button class="button is-success is-active"
          @click="getTextSearch">סנן</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      sortby: "all",
      term: "",
      sortdir: "up",
      orderby: "nextPayment"
    };
  },

  methods: {
    getSortlist() {
      this.$store.dispatch("setSortby", this.sortby);
      this.term = "";
    },
    getTextSearch() {
      this.$store.dispatch("getTextSearch", this.term);
      this.sortby = "all";
    },
    setSortDir() {
      this.$store.dispatch("setSortDir", this.sortdir);
    },
    setOrderby() {
      this.$store.dispatch("setOrderby", this.orderby);
    }
  }
};
</script>

<style lang="scss">
.sub-filter {
  .control {
    text-align: right;
  }
}

.text-search {
  .input {
    display: inline-block;
    max-width: 70%;
  }
  .button {
    display: inline-block;
    max-width: 30%;
  }
}
</style>
